export const normalizeOfferingOptions=(options)=>{
  if (!Array.isArray(options)) return [];

  return options
    .map((group)=>({
      name:String(group?.name || '').trim(),
      required:Boolean(group?.required),
      multiple:Boolean(group?.multiple),
      values:Array.isArray(group?.values)
        ? group.values
            .map((value)=>({
              label:String(value?.label || '').trim(),
              price:Number(value?.price) || 0,
              pricing_mode:value?.pricing_mode==='once_per_order'
                ? 'once_per_order'
                : 'per_item'
            }))
            .filter((value)=>value.label)
        : []
    }))
    .filter((group)=>group.name && group.values.length);
};

export const getOptionPriceAdjustment=(options,selection,quantity=1)=>{
  const normalizedOptions=normalizeOfferingOptions(options);
  const itemQuantity=Math.max(1,Number(quantity) || 1);

  return normalizedOptions.reduce((total,group)=>{
    const selected=selection?.[group.name];
    const selectedValues=Array.isArray(selected) ? selected : [selected];

    return total + selectedValues
      .filter(Boolean)
      .reduce((sum,label)=>{
        const value=group.values.find((item)=>item.label===label);

        if (!value) return sum;

        return sum + value.price * (
          value.pricing_mode==='once_per_order'
            ? 1
            : itemQuantity
        );
      },0);
  },0);
};

export const getOptionUnitPriceAdjustment=(options,selection)=>(
  getOptionPriceAdjustment(options,selection,1)
);

export const getOptionSelectionLabel=(selection)=>{
  return Object.entries(selection || {})
    .flatMap(([group,value])=>{
      const values=Array.isArray(value) ? value : [value];
      return values.filter(Boolean).map((item)=>`${group}: ${item}`);
    })
    .join(', ');
};

export const getMissingRequiredOptionGroups=(options,selection)=>{
  return normalizeOfferingOptions(options)
    .filter((group)=>group.required)
    .filter((group)=>{
      const selected=selection?.[group.name];

      return Array.isArray(selected)
        ? selected.length===0
        : !selected;
    })
    .map((group)=>group.name);
};